<script lang="ts">
	import type { ClassValue } from "svelte/elements";
	import type { Post } from "@core/schema/Post.js";
	import { toDateMonthYearFormat } from "@core/utils/toDateMonthYearFormat.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";

	const { tenant } = getGlobalTemplateProps();
	const {
		post,
		class: customClass = "text-sm/normal sm:text-base",
	}: { post: Pick<Post, "publishedAt">; class?: ClassValue } = $props();
</script>

{#if post.publishedAt !== undefined}
	<time datetime={post.publishedAt} class={["text-fcrgray", customClass]}>
		{toDateMonthYearFormat(post.publishedAt, tenant.locale)}
	</time>
{/if}
